const isSourceNode = node => // For some reason, comparison by identity is not working here :/
// eslint-disable-next-line no-underscore-dangle
node.type.__isSourceNode === true;

export default isSourceNode;